import { Map, List } from 'immutable';

export const timeIntervals = List([
  Map({ label: 'All', value: '' }),
  Map({ label: '1 Day', value: 1 }),
  Map({ label: '3 Days', value: 3 }),
  Map({ label: '1 Week', value: 7 }),
  Map({ label: '2 Weeks', value: 14 }),
  Map({ label: '1 Month', value: 30 }),
  Map({ label: '2 Months', value: 60 }),
  Map({ label: '6 Months', value: 180 }),
  Map({ label: '1 Year', value: 365 }),
]);

export const propertyTypes = List([
  Map({ label: 'Website', value: 'web', code: '1' }),
  Map({ label: 'App', value: 'app', code: '2' }),
  Map({ label: 'OTT', value: 'ott', code: '3' }),
  Map({ label: 'AMP', value: 'amp', code: '5' }),
]);

export const propertyTypesNum = List([
  Map({ label: 'Website', value: '1', code: 'web' }),
  Map({ label: 'App', value: '2', code: 'app' }),
  Map({ label: 'OTT', value: '3', code: 'ott' }),
  Map({ label: 'AMP', value: '5', code: 'amp' }),
]);

export const sortedBy = List([
  Map({ label: 'Most Recent first', value: '1' }),
  Map({ label: 'Oldest first', value: '2' }),
  Map({ label: 'Alphabetical(A-Z)', value: '3' }),
  Map({ label: 'Alphabetical(Z-A)', value: '4' }),
]);

export const createdInPast = List([
  Map({ label: 'All', value: 'All' }),
  Map({ label: '1 day', value: '1 days' }),
  Map({ label: '3 days', value: '3 days' }),
  Map({ label: '1 week', value: '1 weeks' }),
  Map({ label: '3 weeks', value: '3 weeks' }),
  Map({ label: '1 month', value: '1 month' }),
  Map({ label: '2 months', value: '2 months' }),
]);

export const propertyTypesAll = propertyTypes.unshift(
  Map({ label: 'All', value: '' })
);

export const propertyTypesStandards = List([
  Map({ label: 'All', value: 'all' }),
  Map({ label: 'Active', value: 'active' }),
  Map({ label: 'Inactive', value: 'inactive' }),
]);

export const policiesTwo = List([
  Map({ label: 'TCF v2', value: 'tcfv2' }),
  Map({ label: 'U.S. Privacy', value: 'ccpa' }),
]);

export const policiesMultiCampaign = List([
  Map({ label: 'GDPR Compliance ', value: 'gdpr' }),
  Map({ label: 'U.S. Privacy Compliance (legacy)', value: 'ccpa' }),
  Map({ label: 'U.S. MultiState Privacy Compliance', value: 'usnat' }),
  Map({ label: 'Preferences', value: 'preferences' }),
  Map({ label: 'Anti-Adblock', value: 'adBlock' }),
  Map({ label: 'iOS Tracking', value: 'iOSTracking' }),
  Map({ label: 'Custom Messaging', value: 'custom' }),
]);

export function hasFeature(accountFeatures, feature){
  return accountFeatures.includes(feature);
};

export function getPolicies(accountFeatures){
  let policies = policiesTwo;

  const hasTcfv2 = hasFeature(accountFeatures, 'tcf_v2');
  const hasNonIab = hasFeature(accountFeatures, 'non_iab_vl');
  const hasCcpa = hasFeature(accountFeatures, 'ccpa');
  const hasUsnat = hasFeature(accountFeatures, 'usnat');

  if(!hasTcfv2 && !hasNonIab) {
	policies = policies.filter(p => p.get('value') != 'tcfv2');
  }

  if(!hasCcpa) {
	policies = policies.filter(p => p.get('value') != 'ccpa');
  }

  if(!hasUsnat) {
  policies = policies.filter(p => p.get('value') != 'usnat');
  }

  return policies;
}

export function getMultiCampaignPolicies(accountFeatures, propertyType){
  let policies = policiesMultiCampaign;

  const hasTcfv2 = hasFeature(accountFeatures, 'tcf_v2');
  const hasNonIab = hasFeature(accountFeatures, 'non_iab_vl');
  const hasCcpa = hasFeature(accountFeatures, 'ccpa');
  const hasUsnat = hasFeature(accountFeatures, 'usnat');
  const hasAdblock = hasFeature(accountFeatures, 'adblock_v2');
  const hasAppleMessaging = hasFeature(accountFeatures, 'apple_messaging');
  const hasCustomMessaging = hasFeature(accountFeatures, 'custom_messages');
  const hasPreferences = hasFeature(accountFeatures, 'preferences');

  if(!hasTcfv2 && !hasNonIab) {
	policies = policies.filter(p => p.get('value') != 'gdpr');
  }

  if(!hasCcpa) {
	  policies = policies.filter(p => p.get('value') != 'ccpa');
  }

  if(!hasUsnat) {
	  policies = policies.filter(p => p.get('value') != 'usnat');
  }

  if(!hasAdblock || propertyType != 'web') {
	  policies = policies.filter(p => p.get('value') != 'adBlock');
  }

  if(!hasAppleMessaging || propertyType === 'web' || propertyType === 'ott') {
	  policies = policies.filter(p => p.get('value') != 'iOSTracking');
  }

  if(!hasCustomMessaging || propertyType === 'ott') {
    policies = policies.filter(p => p.get('value') != 'custom');
  }

  if(!hasPreferences) {
    policies = policies.filter(p => p.get('value') != 'preferences');
  }

  return policies;
}

const GDPRTCFV2stubFile = `<script>"use strict";function _typeof(t){return(_typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}!function(){var t=function(){var t,e,o=[],n=window,r=n;for(;r;){try{if(r.frames.__tcfapiLocator){t=r;break}}catch(t){}if(r===n.top)break;r=r.parent}t||(!function t(){var e=n.document,o=!!n.frames.__tcfapiLocator;if(!o)if(e.body){var r=e.createElement("iframe");r.style.cssText="display:none",r.name="__tcfapiLocator",e.body.appendChild(r)}else setTimeout(t,5);return!o}(),n.__tcfapi=function(){for(var t=arguments.length,n=new Array(t),r=0;r<t;r++)n[r]=arguments[r];if(!n.length)return o;"setGdprApplies"===n[0]?n.length>3&&2===parseInt(n[1],10)&&"boolean"==typeof n[3]&&(e=n[3],"function"==typeof n[2]&&n[2]("set",!0)):"ping"===n[0]?"function"==typeof n[2]&&n[2]({gdprApplies:e,cmpLoaded:!1,cmpStatus:"stub"}):o.push(n)},n.addEventListener("message",(function(t){var e="string"==typeof t.data,o={};if(e)try{o=JSON.parse(t.data)}catch(t){}else o=t.data;var n="object"===_typeof(o)&&null!==o?o.__tcfapiCall:null;n&&window.__tcfapi(n.command,n.version,(function(o,r){var a={__tcfapiReturn:{returnValue:o,success:r,callId:n.callId}};t&&t.source&&t.source.postMessage&&t.source.postMessage(e?JSON.stringify(a):a,"*")}),n.parameter)}),!1))};"undefined"!=typeof module?module.exports=t:t()}();</script>`

const CCPAstubFile = `<script>(function () { var e = false; var c = window; var t = document; function r() { if (!c.frames["__uspapiLocator"]) { if (t.body) { var a = t.body; var e = t.createElement("iframe"); e.style.cssText = "display:none"; e.name = "__uspapiLocator"; a.appendChild(e) } else { setTimeout(r, 5) } } } r(); function p() { var a = arguments; __uspapi.a = __uspapi.a || []; if (!a.length) { return __uspapi.a } else if (a[0] === "ping") { a[2]({ gdprAppliesGlobally: e, cmpLoaded: false }, true) } else { __uspapi.a.push([].slice.apply(a)) } } function l(t) { var r = typeof t.data === "string"; try { var a = r ? JSON.parse(t.data) : t.data; if (a.__cmpCall) { var n = a.__cmpCall; c.__uspapi(n.command, n.parameter, function (a, e) { var c = { __cmpReturn: { returnValue: a, success: e, callId: n.callId } }; t.source.postMessage(r ? JSON.stringify(c) : c, "*") }) } } catch (a) { } } if (typeof __uspapi !== "function") { c.__uspapi = p; __uspapi.msgHandler = l; c.addEventListener("message", l, false) } })();
</script>`

const USNATstubFile = `<script>
window.__gpp_addFrame=function(e){if(!window.frames[e])if(document.body){var t=document.createElement("iframe");t.style.cssText="display:none",t.name=e,document.body.appendChild(t)}else window.setTimeout(window.__gpp_addFrame,10,e)},window.__gpp_stub=function(){var e=arguments;if(__gpp.queue=__gpp.queue||[],__gpp.events=__gpp.events||[],!e.length||1==e.length&&"queue"==e[0])return __gpp.queue;if(1==e.length&&"events"==e[0])return __gpp.events;var t=e[0],p=e.length>1?e[1]:null,s=e.length>2?e[2]:null;if("ping"===t)p({gppVersion:"1.1",cmpStatus:"stub",cmpDisplayStatus:"hidden",signalStatus:"not ready",supportedAPIs:["2:tcfeuv2","5:tcfcav1","6:uspv1","7:usnatv1","8:uscav1","9:usvav1","10:uscov1","11:usutv1","12:usctv1"],cmpId:0,sectionList:[],applicableSections:[],gppString:"",parsedSections:{}},!0);else if("addEventListener"===t){"lastId"in __gpp||(__gpp.lastId=0),__gpp.lastId++;var n=__gpp.lastId;__gpp.events.push({id:n,callback:p,parameter:s}),p({eventName:"listenerRegistered",listenerId:n,data:!0,pingData:{gppVersion:"1.1",cmpStatus:"stub",cmpDisplayStatus:"hidden",signalStatus:"not ready",supportedAPIs:["2:tcfeuv2","5:tcfcav1","6:uspv1","7:usnatv1","8:uscav1","9:usvav1","10:uscov1","11:usutv1","12:usctv1"],cmpId:0,sectionList:[],applicableSections:[],gppString:"",parsedSections:{}}},!0)}else if("removeEventListener"===t){for(var a=!1,i=0;i<__gpp.events.length;i++)if(__gpp.events[i].id==s){__gpp.events.splice(i,1),a=!0;break}p({eventName:"listenerRemoved",listenerId:s,data:a,pingData:{gppVersion:"1.1",cmpStatus:"stub",cmpDisplayStatus:"hidden",signalStatus:"not ready",supportedAPIs:["2:tcfeuv2","5:tcfcav1","6:uspv1","7:usnatv1","8:uscav1","9:usvav1","10:uscov1","11:usutv1","12:usctv1"],cmpId:0,sectionList:[],applicableSections:[],gppString:"",parsedSections:{}}},!0)}else"hasSection"===t?p(!1,!0):"getSection"===t||"getField"===t?p(null,!0):__gpp.queue.push([].slice.apply(e))},window.__gpp_msghandler=function(e){var t="string"==typeof e.data;try{var p=t?JSON.parse(e.data):e.data}catch(e){p=null}if("object"==typeof p&&null!==p&&"__gppCall"in p){var s=p.__gppCall;window.__gpp(s.command,(function(p,n){var a={__gppReturn:{returnValue:p,success:n,callId:s.callId}};e.source.postMessage(t?JSON.stringify(a):a,"*")}),"parameter"in s?s.parameter:null,"version"in s?s.version:"1.1")}},"__gpp"in window&&"function"==typeof window.__gpp||(window.__gpp=window.__gpp_stub,window.addEventListener("message",window.__gpp_msghandler,!1),window.__gpp_addFrame("__gppLocator"));
</script>`

const adBlockSnippet = `<script src='https://tcfv2-staging-script.s3.amazonaws.com/detection/1.0.0/detection.js' async></script>`;

const env = process.env.NODE_ENV;

const stageScripts = `<script src='https://cdn.sp-stage.net/unified/wrapperMessagingWithoutDetection.js' async></script>`;

const stageMessagingScript = `<script src='https://d18gnmgplhnkao.cloudfront.net/js/messaging.js'></script>`;

const prodScripts = `<script src='https://cdn.privacy-mgmt.com/unified/wrapperMessagingWithoutDetection.js' async></script>`;

const prodMessagingScript = `<script src='https://d3fkv551xkjrmm.cloudfront.net/js/messaging.js'></script>`;

const wrapperScript = env !== 'production' ? stageScripts : prodScripts;

const messagingScript = env !== 'production' ? stageMessagingScript : prodMessagingScript;

const stageDetectionBaseEndPoint = `baseEndpoint: 'https://d18gnmgplhnkao.cloudfront.net'`;

const prodDetectionBaseEndPoint = `baseEndpoint: 'https://d3fkv551xkjrmm.cloudfront.net'`;

const detectionEndPoints =  env !== 'production' ? stageDetectionBaseEndPoint : prodDetectionBaseEndPoint;

const stageBaseEndpoint = `'https://cdn.sp-stage.net'`;

const prodBaseEndpoint = `'https://cdn.privacy-mgmt.com'`;

const baseEndpoint = env !== 'production' ? stageBaseEndpoint : prodBaseEndpoint;


function getEventHandlers(isPreferenceOnly) {
  const Event = {
    MESSAGE_CHOICE_SELECT: 'onMessageChoiceSelect',
    MESSAGE_READY: 'onMessageReady',
    MESSAGE_CHOICE_ERROR: 'onMessageChoiceError',
    PRIVACY_MANAGER_ACTION: 'onPrivacyManagerAction',
    PM_CANCEL: 'onPMCancel',
    PM_PREF_CANCEL: 'onPrefCancel',
    MESSAGE_RECEIVE_DATA: 'onMessageReceiveData',
    SPPM_OBJECT_READY: 'onSPPMObjectReady',
    CONSENT_READY: 'onConsentReady',
    ERROR: 'onError',
    SP_READY: 'onSPReady'
  };
  
  const events = {
    [Event.MESSAGE_READY]: `function() {
              console.log('[event] ${Event.MESSAGE_READY}', arguments);
            }`,
    [Event.MESSAGE_RECEIVE_DATA]: `function() {
              console.log('[event] ${Event.MESSAGE_RECEIVE_DATA}', arguments);
            }`,
    [Event.SPPM_OBJECT_READY]: `function() {
              console.log('[event] ${Event.SPPM_OBJECT_READY}', arguments);
            }`,
    [Event.SP_READY]: `function() {
              console.log('[event] ${Event.SP_READY}', arguments);
            }`,
    [Event.ERROR]: `function() {
              console.log('[event] ${Event.ERROR}', arguments);
            }`
  };

  if (!isPreferenceOnly) {
    events[Event.MESSAGE_CHOICE_SELECT] = `function() {
              console.log('[event] ${Event.MESSAGE_CHOICE_SELECT}', arguments);
            }`;
    events[Event.CONSENT_READY] = `function(consentUUID, euconsent) {
              console.log('[event] ${Event.CONSENT_READY}', arguments);
            }`;
    events[Event.PRIVACY_MANAGER_ACTION] = `function() {
              console.log('[event] ${Event.PRIVACY_MANAGER_ACTION}', arguments);
            }`;
    events[Event.PM_CANCEL] = `function() {
              console.log('[event] ${Event.PM_CANCEL}', arguments);
            }`;
  } else {
    events[Event.PM_PREF_CANCEL] = `function() {
              console.log('[event] onPrefCancel', arguments);
            }`;
  }

  return Object.entries(events)
    .map(([key, handler]) => `${key}: ${handler}`)
    .join(',\n');
}

// gdpr, ccpa, adblock, nonTcfv2
export function getMulticampaignSnippet(policiesSelected, accountId) {
  const gdpr = policiesSelected.includes('gdpr');
  const ccpa = policiesSelected.includes('ccpa');
  const usnat = policiesSelected.includes('usnat');
  const custom = policiesSelected.includes('custom');
  const adBlock = policiesSelected.includes('adBlock');
  const nonTcfv2 = policiesSelected.includes('nonTcfv2');
  const preferences = policiesSelected.includes('preferences');

  const isPreferenceOnly = preferences && !(gdpr || ccpa || usnat || custom || adBlock || nonTcfv2);

  let CCPAstub = '';
  let GDPRstub = '';
  let USNATstub = '';
  let gdprObject = '';
  if (gdpr && !nonTcfv2) {
    GDPRstub += GDPRTCFV2stubFile;
    gdprObject = 'gdpr: { }';
  } else if (gdpr) {
    gdprObject = 'gdpr: { includeTcfApi: false }';
  }
  if (ccpa) {
    CCPAstub = CCPAstubFile;
  }
  if (usnat) {
    USNATstub = USNATstubFile;
  }
  let detectionSnippet = '';
  if (adBlock) {
    detectionSnippet = messagingScript;
  }

  const eventHandlers = getEventHandlers(isPreferenceOnly);

  const baseMulticampaignSnippet = `<script>
    window._sp_queue = [];
    window._sp_ = {
        config: {
            accountId: ${accountId},
            baseEndpoint: ${baseEndpoint},
            ${ccpa ? 'ccpa: { },' : '' }
            ${usnat ? 'usnat: { },' : '' }
            ${custom ? 'custom: { },' : '' }
            ${adBlock ? `detection: { ${detectionEndPoints} },` : '' }
            ${gdprObject ? `${gdprObject},` : ''}
            ${preferences ? 'preferences: { },' : ''}
            events: {
              ${eventHandlers}
            }
        }
    }
    </script>
    ${wrapperScript}`;
    
  return (
   `${GDPRstub}

    ${CCPAstub}

    ${USNATstub}

    ${baseMulticampaignSnippet}
    
    ${detectionSnippet}`
  );
}

const gdprv2StubFile = `<script>"use strict";function _typeof(t){return(_typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}!function(){var t=function(){var t,e,o=[],n=window,r=n;for(;r;){try{if(r.frames.__tcfapiLocator){t=r;break}}catch(t){}if(r===n.top)break;r=r.parent}t||(!function t(){var e=n.document,o=!!n.frames.__tcfapiLocator;if(!o)if(e.body){var r=e.createElement("iframe");r.style.cssText="display:none",r.name="__tcfapiLocator",e.body.appendChild(r)}else setTimeout(t,5);return!o}(),n.__tcfapi=function(){for(var t=arguments.length,n=new Array(t),r=0;r<t;r++)n[r]=arguments[r];if(!n.length)return o;"setGdprApplies"===n[0]?n.length>3&&2===parseInt(n[1],10)&&"boolean"==typeof n[3]&&(e=n[3],"function"==typeof n[2]&&n[2]("set",!0)):"ping"===n[0]?"function"==typeof n[2]&&n[2]({gdprApplies:e,cmpLoaded:!1,cmpStatus:"stub"}):o.push(n)},n.addEventListener("message",(function(t){var e="string"==typeof t.data,o={};if(e)try{o=JSON.parse(t.data)}catch(t){}else o=t.data;var n="object"===_typeof(o)&&null!==o?o.__tcfapiCall:null;n&&window.__tcfapi(n.command,n.version,(function(o,r){var a={__tcfapiReturn:{returnValue:o,success:r,callId:n.callId}};t&&t.source&&t.source.postMessage&&t.source.postMessage(e?JSON.stringify(a):a,"*")}),n.parameter)}),!1))};"undefined"!=typeof module?module.exports=t:t()}();</script>`
const ccpaStubFile = `<script type="text/javascript">(function () { var e = false; var c = window; var t = document; function r() { if (!c.frames["__uspapiLocator"]) { if (t.body) { var a = t.body; var e = t.createElement("iframe"); e.style.cssText = "display:none"; e.name = "__uspapiLocator"; a.appendChild(e) } else { setTimeout(r, 5) } } } r(); function p() { var a = arguments; __uspapi.a = __uspapi.a || []; if (!a.length) { return __uspapi.a } else if (a[0] === "ping") { a[2]({ gdprAppliesGlobally: e, cmpLoaded: false }, true) } else { __uspapi.a.push([].slice.apply(a)) } } function l(t) { var r = typeof t.data === "string"; try { var a = r ? JSON.parse(t.data) : t.data; if (a.__cmpCall) { var n = a.__cmpCall; c.__uspapi(n.command, n.parameter, function (a, e) { var c = { __cmpReturn: { returnValue: a, success: e, callId: n.callId } }; t.source.postMessage(r ? JSON.stringify(c) : c, "*") }) } } catch (a) { } } if (typeof __uspapi !== "function") { c.__uspapi = p; __uspapi.msgHandler = l; c.addEventListener("message", l, false) } })();</script>`;
function gdprv2Config(accountId) {
  return `window._sp_ = {
    config: {
        accountId: ${accountId},
        baseEndpoint: 'https://cdn.privacy-mgmt.com',
    }
}`;
}
function ccpaConfig(accountId) {
  return `window._sp_ccpa = {
    config: {
            mmsDomain: "https://message.sp-prod.net",
            ccpaOrigin: "https://ccpa-service.sp-prod.net",
            accountId: ${accountId},
            getDnsMsgMms: true,
            alwaysDisplayDns: false
    }
}`;
}
const gdprv2js = `<script src="https://cdn.privacy-mgmt.com/wrapperMessagingWithoutDetection.js"></script>`;
const ccpajs = `<script src="https://ccpa.sp-prod.net/ccpa.js"></script>`;

function gdprInApp(propertyDet, accountId){
return `GDPR IOS:
accountId: ${accountId},
propertyId: ${propertyDet.id},
propertyName: try! GDPRPropertyName("${propertyDet.domain}"),
PMId: PRIVACY_MANAGER_ID_HERE,
campaignEnv: .Public,
consentDelegate: self

GDPR Android:
"accountId": ${accountId},
"propertyId": ${propertyDet.id},
"propertyName": "${propertyDet.domain}",
"pmId": PRIVACY_MANAGER_ID_HERE`;
}
function ccpaInApp(propertyDet, accountId){
return  `CCPA Android:
"accountId": ${accountId},
"propertyId": ${propertyDet.id},
"propertyName": "${propertyDet.domain}",
"pmId": PRIVACY_MANAGER_ID_HERE

CCPA IOS:
accountId: ${accountId},
propertyId: ${propertyDet.id},
propertyName: try! PropertyName("${propertyDet.domain}"),
PMId: PRIVACY_MANAGER_ID_HERE,
campaignEnv: .Public,
consentDelegate: self`;
}

export function getSnippet(policiesSelected, accountId, propertyDet) {
  const gdpr = policiesSelected.includes('tcfv2');
  const ccpa = policiesSelected.includes('ccpa');
  return propertyDet.type == 'app'? `${gdpr ? gdprInApp(propertyDet, accountId) : ''} ${ccpa ? ccpaInApp(propertyDet, accountId) : ''}` : `${gdpr ? gdprv2StubFile : ''} 
${ccpa ? ccpaStubFile : ''} 
${gdpr || ccpa ? '<script>' : ''}
${gdpr ? gdprv2Config(accountId) : ''}
${ccpa ? ccpaConfig(accountId) : ''}
${gdpr || ccpa ? '</script>' : ''}
${gdpr ? gdprv2js : ''}
${ccpa ? ccpajs : ''}`;
}

export const gdprDocLink =
  'https://documentation.sourcepoint.com/web-implementation/sourcepoint-gdpr-and-tcf-v2-support/gdpr-and-tcf-v2-setup-and-configuration_v1.1.3';

export const ccpaDocLink =
  'https://documentation.sourcepoint.com/web-implementation/sourcepoint-setup-and-ccpa-configuration';

export const WEB_DOC_LINK_MULTICAMPAIGN = "https://docs.sourcepoint.com/hc/en-us/sections/1500001157062-CMP-Web-implementation";

export const WEB_DOC_LINK_LEGACY = "https://docs.sourcepoint.com/hc/en-us/sections/4405397171859-CMP-Web-implementation-Legacy-";

export const APP_DOC_LINK = "https://docs.sourcepoint.com/hc/en-us/sections/1500001140561-CMP-Mobile-implementation";

export const OTT_DOC_LINK = "https://docs.sourcepoint.com/hc/en-us/sections/1500001157122-CMP-OTT-implementation";

export const AMP_DOC_LINK = "https://docs.sourcepoint.com/hc/en-us/sections/4406897669011-AMP-Accelerated-Mobile-Pages-";

export const getDocImplemnationLink = (propertyType, isMultiCampaignEnabled) =>{
  let docImplemenationLink;
  let propertyLabel;
  switch(propertyType) {
    case 'web':
      docImplemenationLink = isMultiCampaignEnabled? WEB_DOC_LINK_MULTICAMPAIGN : WEB_DOC_LINK_LEGACY
      propertyLabel = 'website';
      break;
    case 'ott':
      docImplemenationLink = OTT_DOC_LINK;
      propertyLabel = 'OTT';
      break;
    case 'app':
      docImplemenationLink = APP_DOC_LINK;
      propertyLabel = 'mobile';
      break;
    case 'amp':
      docImplemenationLink = AMP_DOC_LINK;
      propertyLabel = 'AMP';
      break
    default:
      docImplemenationLink = "https://docs.sourcepoint.com/";
      propertyLabel = 'Domain';
      break;
  }
  return { docImplemenationLink, propertyLabel }
}

export const platforms = [
  { label: 'iOS (Swift)', value: 'swift' },
  { label: 'iOS (ObjectiveC)', value: 'objectiveC' },
  { label: 'Android (Kotlin)', value: 'kotlin' },
  { label: 'Android (Java)', value: 'java' },
];

export function getAppSnippet(campaignTypes, accountId, propertyDet, platform) {
  const propertyName = propertyDet.domain;
  let snippet = 'Code will be displayed after you select the campaign type and platform';
  const isGdpr = campaignTypes.includes('gdpr');
  const isCcpa = campaignTypes.includes('ccpa');
  const isIOSTracking = campaignTypes.includes('iOSTracking');

  switch(platform) {

    case 'swift':  
    snippet = `let manager = SPConsentManager(
      accountId: ${accountId},
      propertyName: try! SPPropertyName("${propertyName}"),
      campaigns: SPCampaigns(
        ${ isGdpr ? 'gdpr: SPCampaign(),' : '' }
        ${ isCcpa ? 'ccpa: SPCampaign(),' : '' }
        ${ isIOSTracking ? 'ios14: SPCampaign()' : '' }
      ),
      delegate: self
    )
    manager.loadMessage()`;
    break;

    case 'objectiveC':
      snippet = `SPPropertyName *propertyName = [[SPPropertyName alloc] init:@"${propertyName}" error:NULL];
SPCampaign *campaign = [[SPCampaign alloc]
    initWithEnvironment: SPCampaignEnvPublic
    targetingParams: [NSDictionary dictionary]];
SPCampaigns *campaigns = [[SPCampaigns alloc]
    initWithGdpr: ${ isGdpr ? 'campaign' : 'NULL'}
    ccpa: ${ isCcpa ? 'campaign' : 'NULL'}
    ios14: ${ isIOSTracking ? 'campaign' : 'NULL'}];
consentManager = [[SPConsentManager alloc]
    initWithAccountId:${accountId}
    propertyName: propertyName
    campaigns: campaigns
    delegate: self];
[consentManager loadMessageForAuthId: NULL];`;
    break;

   case 'kotlin':
     snippet = `private val spConsentLib by spConsentLibLazy {
     activity = <Activity>
     spClient = <SpClient instance>
     privacyManagerTab = PMTab.FEATURES
     config {
         accountId = ${accountId}
         propertyName = "${propertyName}"
         ${ isCcpa ? '+CampaignType.CCPA' : '' }
         ${ isGdpr ? '+CampaignType.GDPR' : '' }
     }
 }
// show the message 
// called inside onResume
spConsentLib.loadMessage()
// called inside onDestroy to release all resources
spConsentLib.dispose()`;
   break;

   case 'java':
     snippet = `private final SpConfig spConfig = new SpConfigDataBuilder()
            .addAccountId(${accountId})
            .addPropertyName("${propertyName}")
            ${ isGdpr ? '.addCampaign(CampaignType.GDPR)' : ''}
            ${ isCcpa ? '.addCampaign(CampaignType.CCPA)' : '' }
            .build();
private SpConsentLib spConsentLib = FactoryKt.makeConsentLib(
                spConfig,
                <Activity ref>,
                <SpClient instance>,
                MessageLanguage.ENGLISH
        );
// show the message
// called inside onResume
spConsentLib.loadMessage();
// called inside onDestroy to release all resources
spConsentLib.dispose();`;
   break;
   
  }

  return snippet;
}